import configureStore, { history } from 'common/configure-store';
import { autoSyncMiddleware } from 'admin/middleware/auto-sync-middleware';
import { editOperationsMiddleware } from 'admin/middleware/edit-operations-middleware';
import stateSyncMiddleware from 'admin/middleware/state-sync-middleware';
import { isEditOperationsSave } from 'admin/utils/story-save-mechanism';
import multiTabStorySync from 'admin/components/pages/Story/MultiTabSync/state-middleware-config';
import reducer, { AdminReducerState } from './reducers';

/**
 * snapshot: auto save changes that made in story/card editor;
 * edit-operations: save every story/card editor write as edit operations applied by the AI server.
 */
const editorSaveMiddleware = () => (isEditOperationsSave ? editOperationsMiddleware() : autoSyncMiddleware());

const middleware = () => [
	/* sync story between different browsing context(tab,window,etc.) of the same origin */
	stateSyncMiddleware(multiTabStorySync),
	editorSaveMiddleware(),
];

export { history };

const adminStore = configureStore({} as AdminReducerState, reducer, { middleware, id: 'adminStore' });

export default adminStore;
